import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const PlusIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 14),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    children: /*#__PURE__*/jsx("path", {
      d: "M7.2 1.7v11.1M1.7 7.2h11.1"
    })
  });
};

export { PlusIcon };
//# sourceMappingURL=plus.js.map
